document.querySelectorAll('.product-card-wrapper').forEach(card => {
  card.addEventListener('mouseenter', () => {
    card.querySelector('.quick-add-button-container').classList.add('show-button');
  });
  
  card.addEventListener('mouseleave', () => {
    card.querySelector('.quick-add-button-container').classList.remove('show-button');
    card.querySelector('#quickAddWrapper').classList.remove('show-wrapper');
  });
});

document.querySelectorAll('.quick-add-button-cover').forEach(button => {
  button.addEventListener('click', () => {
    button.parentElement.querySelector('#quickAddWrapper').classList.toggle('show-wrapper');
  });
});